import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { PageMessageService } from "../../services/page-message-service";
import { Contact } from "../../models/contact";
import lanes from "../../models/lane-list";
import 'jquery';
import 'notify';
import { SecurityService } from '../../services/security-service';

@autoinject
export class ReportParametersMillContactDialog {
    constructor(
        private securityService: SecurityService,
        protected controller: DialogController,
        private busyService: BusyService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {

        this.lanes = lanes;

    }


    parameters: Array<string> = [];
    lanes: Array<any>;

    reportName: string;
    fileName: string;
    mills: Array<any> = [];
    contactTypes: Array<any> = [];
    carrierStatuses: Array<any> = [];
    isAllContactTypesSelected: boolean;
    isAllMillsSelected: boolean;
    isAllStatusesSelected: boolean;
    isAllOutboundLanesSelected: boolean;
    isAllInboundLanesSelected: boolean;
    isAllEquipmentSelected: boolean;

    equipment: Array<any> = [];


    // report parameters
    selectedCarrierStatuses: Array<any> = [];
    selectedContactTypeIds: Array<any> = [];
    selectedMillCodes: Array<string> = [];
    selectedInboundLanes: Array<string> = [];
    selectedOutboundLanes: Array<string> = [];
    selectedEquipment: Array<any> = [];
    includeUnassignedCarriers: boolean = true;
    format: string = "PDF";


    activate(settings) {
        this.parameters = settings.parameters;
        this.reportName = settings.reportName;
        this.format = settings.format || this.format;
        this.fileName = settings.fileName || this.reportName;

        this.loadCarrierStatuses();
        this.loadMills();
        this.loadContactTypes();
        this.loadEquipment();

    }

    loadEquipment() {
        this.busyService.on();
        this.api.get("Registration", "GetEquipment")
            .then((result) => {
                this.equipment = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    loadCarrierStatuses() {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierStatuses")
            .then((result) => {
                this.carrierStatuses = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                var mills = JSON.parse(result.response);
                mills.forEach(o => {
                    o.nameAndCode = o.code + ": " + o.name;
                });
                const userDivisions = this.securityService.user.millCodes;
                if (userDivisions.length > 0) {
                    mills = mills.filter(o => userDivisions.indexOf(o.code) > -1);
                }
                this.mills = mills;
            })
            .finally(() => {
                this.busyService.off();
            });
    }


    loadContactTypes() {
        this.busyService.on();
        return this.api.get("Carriers", "GetContactTypes")
            .then((result) => {
                const contactTypes = JSON.parse(result.response);
                const carrierContactTypes = contactTypes.filter(o => o.carrier == true).map(o => ({
                    id: o.id,
                    description: o.description,
                    category: 'Carrier'
                }));
                const divisionContactTypes = contactTypes.filter(o => o.division == true).map(o => ({
                    id: o.id,
                    description: o.description,
                    category: 'Mill/Division'
                }));

                this.contactTypes = [
                    {
                        category: 'Carrier',
                        types: [...carrierContactTypes]
                    },
                    {
                        category: 'Division',
                        types: [...divisionContactTypes]
                    }
                ];
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    runReport(report) {

        var selectedMillCodes = this.selectedMillCodes;
        if (this.isAllMillsSelected) {
            if (this.securityService.user.millCodes.length > 0) {
                selectedMillCodes = this.securityService.user.millCodes;
            } else {
                selectedMillCodes = [];
            }
        }

        var url = this.reportName;
        if (this.parameters.indexOf("status") > -1) {
            url += "&statuses=" + (this.isAllStatusesSelected ? '' : this.selectedCarrierStatuses.toString());
        }
        if (this.parameters.indexOf("mill") > -1) {
            url += "&millCodes=" + (selectedMillCodes.toString());
        }
        if (this.parameters.indexOf("contactType") > -1) {
            url += "&contactTypeIds=" + (this.isAllContactTypesSelected ? '' : this.selectedContactTypeIds.toString());
        }
        if (this.parameters.indexOf("inboundLanes") > -1) {
            url += "&inboundLanes=" + (this.isAllInboundLanesSelected ? '' : this.selectedInboundLanes.toString());
        }
        if (this.parameters.indexOf("outboundLanes") > -1) {
            url += "&outboundLanes=" + (this.isAllOutboundLanesSelected ? '' : this.selectedOutboundLanes.toString());
        }
        if (this.parameters.indexOf("equipment") > -1) {
            url += "&equipment=" + (this.isAllEquipmentSelected ? '' : this.selectedEquipment.toString());
        }
        if (this.parameters.indexOf("unassignedCarriers") > -1) {
            url += "&includeUnassignedCarriers=" + this.isAllMillsSelected;
        }
        var reportFragment = encodeURIComponent(url);
        window.open("/Report/Download?fileName=" + encodeURIComponent(this.fileName) + "&reportFragment=" + reportFragment + "&format=" + this.format);

    }


}